<template>
  <AppInputField class="radio">
    <input v-bind="$attrs" :value="value" @input="updateValue" class="app-input" />
    <label v-if="label" :for="$attrs.id">{{ label }}</label>
  </AppInputField>
</template>

<script>
// Components
import AppInputField from 'Ui/AppInputField'

export default {
  name: 'AppInputRadio',
  inheritAttrs: false,

  components: {
    AppInputField,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      required: true,
    },
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
    },
  },
}
</script>

<style scoped>
.app-input-field {
  position: relative;
}

.app-input-field.radio .app-input {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

label {
  width: 100%;
  text-align: center;
  color: #fff;
  font-weight: 600;
  padding: 4px 13px;
  background-color: var(--c-secondary-600);
  border-radius: 3px;
  margin: 0;
  outline: none;
}

.app-input:checked ~ label,
.app-input:hover ~ label {
  background-color: var(--c-secondary-700);
}
</style>
